import ControlLibraryType from './ControlLibrary.type';
import type { ControlLibrary, LibraryCard, ControlLibraryState, ControlLibraryAction } from './ControlLibrary.reducer.types';

export type { ControlLibrary, LibraryCard };

const initialState: ControlLibraryState = {
  libraries: [],
  librariesTotal: 0,
  selectedLibrary: null,
  cards: [],
  cardsTotal: 0,
  loading: false,
  cardsLoading: false,
};

const ControlLibraryReducer = (state = initialState, action: ControlLibraryAction): ControlLibraryState => {
  switch (action.type) {
    case ControlLibraryType.SET_LOADING:
      return { ...state, loading: action.payload };
    case ControlLibraryType.SET_CARDS_LOADING:
      return { ...state, cardsLoading: action.payload };
    case ControlLibraryType.SET_LIBRARIES:
      return { ...state, libraries: action.payload };
    case ControlLibraryType.APPEND_LIBRARIES:
      return { ...state, libraries: [...state.libraries, ...action.payload] };
    case ControlLibraryType.SET_LIBRARIES_TOTAL:
      return { ...state, librariesTotal: action.payload };
    case ControlLibraryType.SET_SELECTED_LIBRARY:
      return { ...state, selectedLibrary: action.payload, cards: [], cardsTotal: 0 };
    case ControlLibraryType.SET_CARDS:
      return { ...state, cards: action.payload };
    case ControlLibraryType.SET_CARDS_TOTAL:
      return { ...state, cardsTotal: action.payload };
    default:
      return state;
  }
};

export default ControlLibraryReducer;
